import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import SurveyForm from './SurveyForm';
import AlertForm from './AlertForm';
import BlitzAPI from '../../api/BlitzAPI';

export default class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      survey: null,
      toast: null,
    }
  }
  componentDidMount() {
    Promise.all([BlitzAPI.getToast(), BlitzAPI.getSurvey()]).then((responses) => {
      this.setState({
        toast: responses[0].data,
        survey: responses[1].data,
      })
    })
  }

  render() {
    const { survey, toast } = this.state;
    return (
      <div>
        <div style={{ fontSize: 36, fontWeight: "bold", marginTop: 12, marginBottom: 12 }}>Alert</div>
        <AlertForm initialValues={toast} onSubmit={(value) => {
          const params = {
            version: value.version,
            message: value.message,
            link: value.link,
          }
          return BlitzAPI.postToast(params);

        }} />
        <div style={{ fontSize: 36, fontWeight: "bold", marginTop: 12, marginBottom: 12 }}>Survey</div>
        <SurveyForm initialValues={survey} onSubmit={(value) => {
          const params = {
            version: value.version,
            message: value.message,
            link: value.link,
          }
          return BlitzAPI.postSurvey(params);
        }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/alert/Alert.js